import { Languages } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import AnalyticsTab from "./AnalyticsTab";
import LanguagesTab from "./LanguagesTab";
import DictionaryTab from "./DictionaryTab";
import PacksTab from "./PacksTab";

export default function LanguageGovernance() {
  return (
    <div data-testid="language-governance-page">
      <header className="flex items-center gap-3 mb-6">
        <span className="h-10 w-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
          <Languages className="h-5 w-5" />
        </span>
        <div>
          <h1 className="text-xl font-bold text-foreground">Language Governance Center</h1>
          <p className="text-sm text-muted-foreground">Registry · Business terminology · UI packs · Adoption analytics</p>
        </div>
      </header>

      <Tabs defaultValue="analytics">
        <TabsList data-testid="governance-tabs">
          <TabsTrigger value="analytics" data-testid="tab-analytics">Analytics</TabsTrigger>
          <TabsTrigger value="languages" data-testid="tab-languages">Languages</TabsTrigger>
          <TabsTrigger value="dictionary" data-testid="tab-dictionary">Business Dictionary</TabsTrigger>
          <TabsTrigger value="packs" data-testid="tab-packs">Language Packs</TabsTrigger>
        </TabsList>
        <TabsContent value="analytics" className="pt-4"><AnalyticsTab /></TabsContent>
        <TabsContent value="languages" className="pt-4"><LanguagesTab /></TabsContent>
        <TabsContent value="dictionary" className="pt-4"><DictionaryTab /></TabsContent>
        <TabsContent value="packs" className="pt-4"><PacksTab /></TabsContent>
      </Tabs>
    </div>
  );
}
